export default __webpack_public_path__ + "static/media/car_with_road.112c0732.svg";